import { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import defaultHeroImage from "@/assets/atasehir-skyline.webp";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function PageHero({
  title,
  subtitle,
  image,
  overlay = "light",
  variant = "image",
}: {
  title: string;
  subtitle?: string;
  image?: string;
  /** "default" = koyu okuma overlay'i; "light" = ince bordo şeffaf katman, görsel net kalır */
  overlay?: "default" | "light";
  /** "image" = arkaplan görseli; "band" = sade bordo bant, görsel yok */
  variant?: "image" | "band";
}) {
  if (variant === "band") {
    return (
      <section className="relative overflow-hidden bg-gradient-hero text-primary-foreground">
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary to-primary/90" />
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_20%_50%,hsl(var(--accent))_0%,transparent_50%)]" />
        <div className="container-page relative py-14 md:py-20">
          <div className="max-w-3xl animate-fade-up">
            <span className="heading-eyebrow text-primary-foreground/90">Anadolu Terra</span>
            <h1 className="mt-3 font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-primary-foreground">{title}</h1>
            {subtitle && <p className="mt-4 text-base md:text-lg text-primary-foreground/85 max-w-2xl">{subtitle}</p>}
          </div>
        </div>
      </section>
    );
  }

  const heroImage = image || defaultHeroImage;
  return (
    <section className="relative overflow-hidden bg-gradient-hero text-primary-foreground">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt=""
          className={`h-full w-full object-cover ${overlay === "light" ? "opacity-100" : "opacity-25"}`}
        />
        {overlay === "light" ? (
          <>
            {/* İnce bordo şeffaf katman — şehir silüetini bozmaz */}
            <div className="absolute inset-0 bg-primary/35 mix-blend-multiply" />
            {/* Alt taraf metin okunurluğu için yumuşak koyulaşma */}
            <div className="absolute inset-0 bg-gradient-to-t from-ink/55 via-ink/15 to-transparent" />
          </>
        ) : (
          <div className="absolute inset-0 bg-gradient-overlay" />
        )}
      </div>
      <div className="container-page relative py-20 md:py-28">
        <div className="max-w-3xl animate-fade-up">
          <span className={`heading-eyebrow drop-shadow ${overlay === "light" ? "text-primary-foreground" : "text-accent"}`}>Anadolu Terra</span>
          <h1 className="mt-3 font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-primary-foreground drop-shadow-lg">{title}</h1>
          {subtitle && <p className="mt-5 text-lg text-primary-foreground/90 max-w-2xl drop-shadow">{subtitle}</p>}
        </div>
      </div>
    </section>
  );
}
